import { ArtistsMsgItem } from '@/types/artist-api'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ArtistState {
    currentType: {
        name: string
        type: number
        url?: string
    }
    currentArea: number
    artistList: ArtistsMsgItem[]
}

const initialState: ArtistState = {
    currentType: {
        name: '推荐歌手',
        type: 1,
    },
    currentArea: 7,
    artistList: [],
}

const artistSlice = createSlice({
    name: 'artist',
    initialState,
    reducers: {
        changeCurrentType(
            state,
            action: PayloadAction<{
                name: string
                type: number
                url?: string
            }>
        ) {
            state.currentType = action.payload
        },
        changeCurrentArea(state, action: PayloadAction<number>) {
            state.currentArea = action.payload
        },
        changeArtistList(state, action: PayloadAction<ArtistsMsgItem[]>) {
            state.artistList = action.payload
        },
    },
})

export const { changeCurrentType, changeCurrentArea, changeArtistList } = artistSlice.actions

export default artistSlice.reducer
